import React, { useState, useEffect } from "react";
import {
  getGeofenceByFleetId,
  getRobotStatus,
  getActiveMission,
  getFleetConfigByFleetId,
} from "../API";
import { findNorthWestAndSouthEast } from "../utils";

import { useParams } from "react-router-dom";
import RobotTracking from "./RobotTracking";
function RobotStatus() {
  const [isLoading, setIsLoading] = useState(true);
  const [robotDetails, setRobotDetails] = useState(null);
  const [robotActiveMission, setRobotActiveMission] = useState([]);
  const { robotId } = useParams();
  const [maxBoundCordinates, setBoundCordinates] = useState({});
  const [geofenceData, setGeofenceData] = useState([]);
  const fetchBoundCordinates = () => {
    getGeofenceByFleetId(process.env.REACT_APP_FLEETID).then(
      (res) => {
        console.log("Geofence response:", res);
        console.log("Geofence data:", res.data);
        console.log("Raw geofence coordinates:", res.data.geofence);
        const bounds = findNorthWestAndSouthEast(res.data.geofence);
        console.log("Calculated bounds:", bounds);
        setBoundCordinates(bounds);
        setGeofenceData(res.data.geofence);
      }
    ).catch((err) => {
      console.log("Error fetching geofence:", err);
    });
  }
  useEffect(() => {
    const intervalId = setInterval(() => {
      getRobotStatus(robotId)
        .then((res) => {
          console.log("Robot Status Response:", res);
          console.log("Robot Details:", res?.data?.data);
          console.log("Robot Status:", res?.data?.data?.robotStatus);
          setRobotDetails(res?.data?.data);
          setIsLoading(false);
        })
        .catch((err) => {
          setIsLoading(true);
          console.log("Error ", err);
        });
    }, 5000);

    return () => {
      clearInterval(intervalId);
    };
  }, [robotId]);


  useEffect(() => {
    fetchBoundCordinates();
    getRobotStatus(robotId)
  },[robotId])

  useEffect(() => {
    const intervalId = setInterval(() => {
      getActiveMission(robotId)
        .then((response) => {
          setRobotActiveMission(response?.data);
        })
        .catch((err) => {
          setIsLoading(true);
          console.log("Error ", err);
        });
    }, 2000);
    return () => {
      clearInterval(intervalId);
    };
  }, [robotId]);

  useEffect(() => {
    const fetchFleetConfig = async () => {
      try {
        const response = await getFleetConfigByFleetId(
          robotDetails?.robotStatus?.fleetId
        );
        const data = response?.data?.data;
        localStorage.setItem("fleetConfig", JSON.stringify(data));
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    if (robotDetails) {
      fetchFleetConfig();
    }
  }, [robotDetails]);

  return (
    <div>
      {/* {false ? (
        <Loader />
      ) : ( */}
      <RobotTracking
        maxBoundCordinates={maxBoundCordinates}
        geofenceData={geofenceData}
        robotDetails={robotDetails}
        robotActiveMission={robotActiveMission}
        isLoading={isLoading}
      />
      {/* )} */}
    </div>
  );
}

export default RobotStatus;
